module.exports = __webpack_public_path__ + "static/img/Pengaturan.578d76f4.jpg";